import React, { Fragment, useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Form,
} from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import CustomInput from "Custom/CustomInput"
import { Field, FormikProvider, useFormik } from "formik"
import * as Yup from "yup"
import CustomSelect from "Custom/CustomSelect"
import CustomFlatpickr from "Custom/CustomFlatpicker"
import { get, post, } from "helpers/api_helper"
import {
  GET_OrganisationDetail,
  GET_ALL_CURRENCY,
  POST_CURRENCY_CON,
  GET_CURRENCY_CON_DETAILS,
} from "../../helpers/url_helper"
import { Spin } from "antd"
import swal from "sweetalert"

const AddCurrencyConversion = props => {
  const navigate = useNavigate()
  const { IdParam } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [currencyFrom, setCurrencyFrom] = useState([])
  const [currencyTo, setCurrencyTo] = useState([])


  const validationSchema = Yup.object().shape({
    from_currency_id: Yup.string().required("From Currency is a required field."),
    to_currency_id: Yup.string().required(
      "To Currency is a required field."
    ), value: Yup.string().required(
      "Value is a required field."
    ),
  })

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values) => handleValidSubmit(values),
    initialValues: {
      from_currency_id: "",
      to_currency_id: "",
      as_of_date: new Date(),
      value: 0,
    },
    validateOnBlur: false,
  })

  const {
    setValues,
    setFieldValue,
    values: {
      from_currency_id,
      to_currency_id,
      as_of_date,
      value,
    },
  } = formik

  useEffect(() => {
    getCurrancyList()
    if (IdParam) {
      getCurrencyConvDetail(IdParam)
    } else {
      getOrganizationDetails()
    }
  }, [])

  const getOrganizationDetails = async () => {
    setIsLoading(true)
    await get(GET_OrganisationDetail)
      .then(res => {
        //console.log("org details: ", res)
        if (res?.status == 200) {
          if (res?.data?.addresses?.length > 1) {
            let orgAddress = res?.data?.addresses?.[1]
            if (orgAddress) {
              // setFieldValue("source_of_supply", orgAddress?.state_id)
              // setFieldValue(
              //   "source_of_supplyStateName",
              //   orgAddress?.state?.state_name
              // )
              // setFieldValue("destination_of_supply", orgAddress?.state_id)
              // setFieldValue(
              //   "destination_of_supplyStateName",
              //   orgAddress?.state?.state_name
              // )
              setFieldValue("deliverToAddress", orgAddress)
            }
          }
          setFieldValue("destination_of_supply", res?.data?.supply_state_code)
          setFieldValue(
            "destination_of_supplyStateName",
            (res?.data?.supply_state?.vehicle_series_code
              ? `[${res?.data?.supply_state?.vehicle_series_code}] `
              : "") + res?.data?.supply_state?.state_name
          )
          setFieldValue("organization_id", res?.data?.id)
        } else {
          setFieldValue("organization_id", 0)
          // setFieldValue("source_of_supply", 0)
          // setFieldValue("source_of_supplyStateName", "")
          setFieldValue("destination_of_supply", 0)
          setFieldValue("destination_of_supplyStateName", "")
          setFieldValue("deliverToAddress", null)
        }
        setIsLoading(false)
      })
      .catch(error => {
        console.log(error)
        setIsLoading(false)
      })
  }

  const getCurrancyList = async () => {
    setIsLoading(true)
    await get(GET_ALL_CURRENCY)
      .then(res => {
        if (res?.status == 200 && res?.data.length > 0) {
          let NewOptions = []
          res?.data?.map(item =>
            NewOptions.push({
              label: item.code,
              value: item.id,
            })
          )
          setCurrencyFrom(NewOptions)
          setCurrencyTo(NewOptions)
        } else {
          setCurrencyFrom([])
          setCurrencyTo([])
        }
        setIsLoading(false)
      })
      .catch(error => {
        console.log(error)
        setIsLoading(false)
      })
  }

  const getCurrencyConvDetail = id => {
    setIsLoading(true)
    get(GET_CURRENCY_CON_DETAILS + id)
      .then(response => {
        if (response?.status == 200) {
          let data = response?.data
          setValues({
            from_currency_id: data.from_currency_id,
            to_currency_id: data.to_currency_id,
            as_of_date: new Date(data.as_of_date),
            value: data.value,
          })
        }
        else {
          swal({
            title: "Error!",
            text: response.message,
            icon: "error",
            button: "OK",
          })
          setIsLoading(false)
        }
      })
      .catch(error => {
        console.log(error)
        setIsLoading(false)
      })
  }


  const handleValidSubmit = async values => {
    setIsLoading(true)
    const payload = IdParam ? { ...values, id: IdParam } : values
    await post(POST_CURRENCY_CON, payload)
      .then(response => {
        if (response?.status == 200) {
          swal("Success!", response?.message, "success")
          setIsLoading(false)
          setTimeout(() => {
            navigate("/currency-conversion")
          }, 1000)

        } else {
          if (typeof response?.message == "string") {
            swal({
              title: "Error!",
              text: response.message,
              icon: "error",
              button: "OK",
            })
          }
          setIsLoading(false)
        }
      })
      .catch(error => {
        console.log(error)
        setIsLoading(false)
      })
  }


  return (
    <React.Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="page-content">
          <MetaTags>
            <title>
              {IdParam ? "Edit Currency Conversion" : "Add Currency Conversion"} | Katlax
              OMS
            </title>
          </MetaTags>

          <Container fluid>
            <Row className="mt-2">
              <Col lg={6}>
                <div style={{ fontSize: "large" }}>
                  <i className="ti-bag" style={{ fontWeight: "800" }}></i>
                  &nbsp;
                  <b>
                    {IdParam ? "Edit Currency Conversion" : "Add Currency Conversion"}
                  </b>
                </div>
              </Col>
            </Row>
            <Row className="mt-3" style={{ borderTop: "1px solid #cacaca" }}>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <FormikProvider value={formik}>
                      <Form onSubmit={formik.handleSubmit}>
                        <Row>
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                              Currency From <span className="text-danger">*</span>
                            </div>
                          </Col>
                          <Col lg={4}>
                            <Field
                              name="from_currency_id"
                              placeholder={"Select Currency"}
                              component={CustomSelect}
                              options={currencyFrom}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                              Currency To <span className="text-danger">*</span>
                            </div>
                          </Col>
                          <Col lg={4}>
                            <Field
                              name="to_currency_id"
                              placeholder={"Select Currency"}
                              component={CustomSelect}
                              options={currencyTo}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                              Date
                            </div>
                          </Col>
                          <Col lg={4}>
                            <Field
                              type="text"
                              name="as_of_date"
                              placeholder={"dd/mm/yyyy"}
                              component={CustomFlatpickr}
                              defaultDate={new Date()}
                              options={{
                                altInput: true,
                                altFormat: "d/m/Y",
                                dateFormat: "d/m/Y",
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                              Conversion value{" "}
                              <span className="text-danger">*</span>
                            </div>
                          </Col>
                          <Col lg={4}>
                            <Field
                              type="number"
                              name="value"
                              placeholder={"Enter Conversion value"}
                              component={CustomInput}
                            />
                          </Col>
                        </Row>

                        <Row className="mt-3">
                          <Col lg={12} style={{ textAlign: "left" }}>
                            <button className="btn btn-primary" type="submit">
                              Save
                            </button>
                            &nbsp;&nbsp;
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => {
                                navigate("/currency-conversion")
                              }}
                            >
                              Cancel
                            </button>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </Spin>
    </React.Fragment >
  )
}
AddCurrencyConversion.propTypes = {
  t: PropTypes.any,
}
export default withRouter(withTranslation()(AddCurrencyConversion))
